import { createSchema } from "../erd-editor-schema/dist/v3/parser/index.js";
import { createStore as createStore$1 } from "../r-html/dist/store/index.js";
import { tableColumnReducers } from "./modules/table-column/atom.actions.js";
import { dictionaryReducers } from "./modules/dictionary/atom.actions.js";
import { createEditor } from "./modules/editor/state.js";
import { settingsReducers } from "./modules/settings/atom.actions.js";
import { editorReducers } from "./modules/editor/atom.actions.js";
import { indexReducers } from "./modules/index/atom.actions.js";
import { indexColumnReducers } from "./modules/index-column/atom.actions.js";
import { memoReducers } from "./modules/memo/atom.actions.js";
import { relationshipReducers } from "./modules/relationship/atom.actions.js";
import { tableReducers } from "./modules/table/atom.actions.js";
import { tableGroupReducers } from "./modules/table-group/atom.actions.js";
//#region src/engine/store.ts
function createStore(context, enableObservable) {
	return createStore$1({
		context,
		state: {
			...createSchema(),
			editor: createEditor(),
			lww: {}
		},
		reducers: {
			...editorReducers,
			...tableReducers,
			...tableColumnReducers,
			...memoReducers,
			...relationshipReducers,
			...settingsReducers,
			...indexReducers,
			...indexColumnReducers,
			...tableGroupReducers,
			...dictionaryReducers
		},
		enableObservable: enableObservable ?? true
	});
}
//#endregion
export { createStore };
